module.exports = __webpack_public_path__ + "img/pageBanner-JoinUs.afec9583.jpg";